/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import AsyncSelect from 'react-select/async';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import DatePicker from "react-datepicker";
import CurrencyInput from 'react-currency-input-field';
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { confirmAlert } from "react-confirm-alert";
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';
import axios from 'axios';

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import AddReceiptService from "../../../services/receipts/addReceiptsService";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations"
import ButtonLoading from "../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";


function CreateRecipts() {

const [successful, setSuccessful] = useState(false);
const [disable, setDisable] = useState(false);
const [loading, setLoading] = useState(false)
const [receipt_number, setReceipt_number] = useState("")
const [receipt_date, setReceipt_date] = useState(new Date())
const [receipt_amount, setReceipt_amount] = useState(0)
const [applied_amount, setApplied_amount] = useState(0)
const [remittance_bank, setRemittance_bank] = useState("")
const [receipt_method, setReceipt_method] = useState("")
const [receipt_reference, setReceipt_reference] = useState("");
const [status, setStatus] = useState("");
const [overide_application, setOveride_application] = useState("");
const [selectedValue2, setSelectedValue2] = useState(null);
const [inputvalue2, setValue2] = useState("");
const [selectedValue, setSelectedValue] = useState(null);
const [inputvalue, setValue] = useState("");
const [receipt_series, setReceiptSeries] = useState("");
const [comments, setComments] = useState("");
const [extrafiledreceipt, setExtraFiled] = useState([])
const [creation_date, setCreationDate] = useState(new Date());
const [filedreceipt, setFiledReceipt] = useState([
	{ attribute0: '' },
	{ attribute1: '' },
	{ attribute2: '' },
	{ attribute3: '' },
	{ attribute4: '' },
	{ attribute5: '' },
	{ attribute6: '' },
	{ attribute7: '' },
	{ attribute8: '' },
	{ attribute9: '' },
	{ attribute10: '' },
	{ attribute11: '' },
	{ attribute12: '' },
	{ attribute13: '' },
	{ attribute14: '' },
])
const checkBtn = useRef();
const { register, handleSubmit, reset,formState: { errors } } = useForm();
const form = useRef();
const navigate = useNavigate()

const [isExpanded, setIsExpanded] = useState(false);
const toggleFields = () => {
  setIsExpanded(!isExpanded);
};

const handelInputChange2 = (value1) => {
	setValue2(value1);
}

const handelChange2 = (value1) => {
	if(value1===null){
		setSelectedValue2(null)
		reset({
			selectedValue2 : null
		})
		reset({
			selectedValue2 : null
		})
		
	}
	else{

		setSelectedValue2(value1)
		reset({
		selectedValue2 : value1
	})
	loadInitialOptions(value1.customer_name)
	reset({
		selectedValue : value1.id,
		selectedValue2 : value1
	})
}
}

const loadOptions2 = async (inputValue2) => {
	if (inputValue2 !== "") {
		const response = await axios.get(
			API + `contracts/contractsactive/filter/?id=${inputValue2}&&customer_id=${selectedValue ? selectedValue.id : ""}`, { headers: authHeader() }
		);
		return response.data.data
	}
};

const handelInputChange = (value) => {
	setValue(value);
}

const handelChange = (value) => {
	if (value ==null){
		setSelectedValue(null)
		reset({
			selectedValue : null
		})
		
	}
	else{

		setSelectedValue(value)
		loadInitialOptions(value.customer_name)
		reset({
			selectedValue : value
		})
	}
	
}

const handelReceipt_Date = (value) => {
	setReceipt_date(value)
	reset({
		receiptdate:value
	})
}

const loadOptions = async (inputValue) => {
	if (inputValue !== "") {
		const responseJSON = await axios.get(
			API + `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`, { headers: authHeader() }
		);
		return responseJSON.data.data
	}
};
const [options, setOptions] = useState([]);
const [options2, setOptions2] = useState([]);
const loadInitialOptions = async (customer) => {
  const responseJSON = await axios.get(
    API + `parties/vendor/?party_type=Customer&&customer_name=${customer}`, { headers: authHeader() }
  );
  setOptions(responseJSON.data.data);

if(selectedValue ==null){
	
		setSelectedValue(responseJSON.data.data[0])
}

};

const loadInitialContract = async (inputValue2) => {
	// if (inputValue2 !== "") {
		const response = await axios.get(
			API + `contracts/contractsactive/filter/?id=${inputValue2}`, { headers: authHeader() }
			// &&customer_id=${selectedValue ? selectedValue.id : ""}`, { headers: authHeader() }
		);
		setOptions2(response.data.data);
		// return response.data.data
	// }
};


useEffect(() => {

	loadInitialOptions("")
	loadInitialContract("")
}, [])

const getExtrafiled = () => {
	GetCompanyInfoService.getExtraFiled().then(
		(response) => {
			setExtraFiled(response.data.existrecipt)
		}
	)
	
}

const locale  = localStorage.getItem('locale')

useEffect(() => {
	reset({
		receiptdate:new Date()
	})
	getExtrafiled()
	receipt_number_method()
	// loadInitialOptions("")
}, [])


const onChangeextrafileds = (e, index) => {
	const { name, value } = e.target
	const rowsInput = [...filedreceipt]
	rowsInput[index][name] = value
	setFiledReceipt(rowsInput)
}


const receipt_number_method = async () => {
 await axios.get(
		API + `receipts/receipt_number_series/`, { headers: authHeader() }
	)
		.then((response) => {
			if (response.data.success === 1) {
				setReceiptSeries(response.data.details)
			}
			else {
				confirmAlert({
					title: "",
					message: 'Go to settings and update Receipt Setting',
					buttons: [
						{
							label: 'OK',
							onClick: () => navigate("/profile")
						}
					]
				})
			}
		})
	
}

const handleRegister = () => {
	form.current.validateAll();
	let customer_id = null;
	let contract_id = null;
	if (checkBtn.current.context._errors.length === 0) {
		if (selectedValue == null) {
			customer_id = selectedValue
		} else {
			customer_id = selectedValue.id
		}
		if (selectedValue2 == null) {
			contract_id = selectedValue2
		} else {
			contract_id = selectedValue2.id
		}
		AddReceiptService.addReceipt(
			Helper.DatePicker(receipt_date),
			receipt_amount,
			applied_amount,
			customer_id,
			contract_id,
			remittance_bank,
			receipt_method,
			receipt_reference,
			status,
			comments,
			overide_application,
			filedreceipt
		).then(
			(response) => {
				if (response.data.success) {
					setSuccessful(true);
					setLoading(false)
					setTimeout(() => {
						setDisable(false)
						navigate("/receipts/editreceipts", { state: response.data.receipt_id })
					}, 1000)
					toast.success(`${response.data.response}`,{
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",})
				}
				else {
					toast.error(`${response.data.error}`,{
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",})
					setSuccessful(false);
					setDisable(false)
				}
			},
		).catch((error) => {
			toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
			  position: "top-right",
			  autoClose: 4000,
			  hideProgressBar: false,
			  pauseOnHover: true,
			  draggable: true,
			  progress: undefined,
			  theme: "light",
			})
	  
		  });
	}
}

const handleclick = () => {
	navigate('/receipts')
}

return (
<>
	<div className="page-wrapper">
		<ToastContainer />
		<div className="content container-fluid">
			<div className="header pb-0 mb-1 pt-3">
				<div className="d-lg-flex">
					<div>
						<h5 className="mb-0">{t("Create New Receipt")}</h5>
						<h6><Link to="/receipts" className="tc">{t("Receipts")}</Link> / <span>{t("New Receipt")}</span></h6>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="success"></div>
								<Form role="form text-left"
									onSubmit={handleSubmit(handleRegister)}
									ref={form}
									action="."
									method="POST"
									id="addReceiptForm" >
									{(
										<>
											<div className="row">
												<div className="">
													<label className="col-lg-6 col-form-label required">{t("Receipt Method")} <Tooltip content={t("ReceiptMethod_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
													<div className="col-lg-12 form-group">
														<select
															className="form-control input-lg" 
															name="receiptmethod" 
															id="receipt_method" 
															{...register("receiptmethod", {onChange: (e) => { setReceipt_method(e.target.value) }, required: true })}
															>
															<option value="">Select Method</option>
															{
																locale === "en_US"?
																<>
																<option value="Check">Check</option>
																<option value="Cash">Cash</option>
																<option value="Card">Card</option>
																<option value="ACH">ACH</option>
																</>
																:
																<>
																<option value="Cheque">Cheque</option>
																<option value="Cash">Cash</option>
																<option value="Card">Card</option>
																<option value="DirectDebit" >Direct Debit</option>
																</>
															}
														</select>
														<div className="invalid-feedback">
														{errors.receiptmethod && "Receipt Method is required"}
														</div>
													</div>
												</div>

												<div className="form-group row">
													<div className="col-xl-6">
														<label className="col-lg-12 col-form-label required">{t("Customer")} <Tooltip content={t("Customer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<AsyncSelect
																{...register("selectedValue",{ required: true })}
																defaultOptions={options}
																isClearable
																options={options}
                            									value={options.find((option) => selectedValue2? option.id === selectedValue2.party:"")}
																placeholder="Search for Customer(%forAll)"
																getOptionLabel={e => e.customer_name}
																getOptionValue={e => e.customer_name}
																loadOptions={loadOptions}
																onInputChange={handelInputChange}
																onChange={handelChange}
																name="selectedValue"
																>
															</AsyncSelect>
															<div className="invalid-feedback" >
															{errors.selectedValue && "Customer is required"}
															</div>
														</div>
													</div>
													<div className="col-xl-6">
														<label className="col-lg-12 col-form-label required ">{t("Contract Number")} <Tooltip content={t("ContractNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<AsyncSelect
																{...register("selectedValue2",{ required: true })}
																defaultOptions={options2}
																isClearable
																options={options2}
																// value={selectedValue2}
																value={options2.find((option) => selectedValue2? option.id === selectedValue2.id:"")}

																placeholder={t("Search for Contract(%for All)")}
																getOptionLabel={e => e.contract_number}
																getOptionValue={e => e.contract_number}
																loadOptions={loadOptions2}
																onInputChange={handelInputChange2}
																onChange={handelChange2}
																name="selectedValue2"
															>
															</AsyncSelect>
															<div className="invalid-feedback" >
															{errors.selectedValue2 && "Contract Number is required"}
															</div>
															<input type="hidden" id="contract_status" value="Active" />
														</div>
													</div>
												</div>
												<div className="form-group row">
													<div className="col-xl-6">
														<label className="col-lg-12 col-form-label">{t("Remittance Bank")} <Tooltip content={t("RemittanceBank_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<input
																onChange={(e) => setRemittance_bank(e.target.value)}
																
																type="text"
																className="form-control"
																name="remittance_bank"
																id="remittance_bank"
															/>
														</div>
													</div>
													<div className="col-xl-6">
														<div className="form-group row">
															<label className="col-lg-12 col-form-label required">{t("Receipt Amount")} <Tooltip content={t("ReceiptAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
															<div className="col-lg-12">
																<CurrencyInput
																	className="form-control"
																	id="input-example"
																	{...register("receiptamount", {  required: true })}
																	allowDecimals="false"
																	onValueChange={(value) => setReceipt_amount(value)}
																	name="receiptamount"
																	disableAbbreviations
																/>
																<div className="invalid-feedback">
																{errors.receiptamount?.type === 'required' && "Receipt Amount  is required"}
															</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-xl-6">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Receipt Reference")} <Tooltip content={t("ReceiptReference_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<input
																onChange={(e) => setReceipt_reference(e.target.value)}
																type="text" className="form-control input-lg" name="receipt_reference" id="receipt_reference" />
														</div>
													</div>
												</div>
												<div className="col-xl-6">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Comments")} <Tooltip content={t("Comments_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<textarea
																onChange={(e) => setComments(e.target.value)}
																type="text" className="form-control input-lg" name="comments" id="comments" />
														</div>
													</div>
												</div>
											</div>
											<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-6 col-form-label required">{t("Receipt Date")} <Tooltip content={t("ReceiptDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-6">
															<DatePicker
																{...register("receiptdate", { required: true })}
																className="form-control datepick"
																selected={receipt_date}
																onChange={(date) => handelReceipt_Date(date)}
																name="receiptdate"
																placeholderText={"mm/dd/yyyy"}
																showYearDropdown // year show and scrolldown alos
																scrollableYearDropdown
																showMonthDropdown
																dropdownMode="select"
															/>
															<div className="invalid-feedback">
                                                                    {errors.receiptdate && "Receipt Date  is required"}
                                                            </div>
														</div>
													</div>
												</div>

											<div className="row">
											</div>
											{
												extrafiledreceipt.length === 0 ?
													"" :
													<h5 className="tc mt-4 cursor-pointer" onClick={toggleFields}>
													{t("Additional Information")} {isExpanded ===true ? <FaAngleUp /> : <FaAngleDown />}
												  </h5>											
											}
											{
                                                isExpanded === true && (
											<div className="form-group row">
												{
													extrafiledreceipt.map((key, index) => (
														<div className={key.enable === "True" ? "col-sm-6" : null}>
															<>
																<label style={{ display: key.enable === 'True' ? true : "none" }} className="col-form-label"> {key.label} <Tooltip content={key.label}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
																<input
																	style={{ display: key.enable === 'True' ? true : "none" }}
																	className="form-control mb-1"
																	name={'attribute' + index}
																	type={key.datatype}
																	placeholder={key.label}
																	onChange={(e) => onChangeextrafileds(e, index)}
																/>
															</>
														</div>
													))
												}
											</div>
												)
											}

											<div className="text-left py-3">
												<input type="hidden" id="receipt_id" />
												<input type="hidden" id="contract_id" />
												<button type="button"
													onClick={handleclick}
													className="btn-save border-0 btn btn-secondary btn-gradient-primary btn-md">{t("Cancel")}</button>&nbsp;&nbsp;
												<button type="submit" disabled={disable} className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md">
													{
														loading === false ? (
															t('Save')
														) : (
															<ButtonLoading />
														)
													}
												</button>&nbsp;&nbsp;
												<button type="button" style={{ display: "none" }} className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-md">{t("Apply")}</button>&nbsp;&nbsp;
											</div>
										</>
									)}
									<CheckButton style={{ display: "none" }} ref={checkBtn} />
								</Form>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="col-xl-12">
									<Form role="form text-left"
										onSubmit={handleSubmit(handleRegister)}
										ref={form}
										action="."
										method="POST"
										id="addReceiptForm" >
										{(
											<>
												<div className="form-group row">
													<label className="col-lg-12 col-form-label required">{t("Receipt Number")} <Tooltip content={t("ReceiptNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
													<div className="col-lg-12">
														<input
															disabled
															type="text"
															className="form-control"
															name="receipt_number"
															id="receipt_number"
															{...register("receipt_number", { onChange: (e) => { setReceipt_number(e.target.value) }, required: false })}
														/>
													</div>
													<div className="invalid-feedback">
														{errors.receipt_number?.type === 'required' && "Receipt Number  is required"}
													</div>
												</div>

												<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Receipt Date")} <Tooltip content={t("ReceiptDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<DatePicker
																// {...register("receiptdate", { required: true })}
																className="form-control datepick"
																selected={receipt_date}
																// onChange={(date) => handelReceipt_Date(date)}
																name="receiptdate"
																placeholderText={"mm/dd/yyyy"}
																showYearDropdown 
																scrollableYearDropdown
																showMonthDropdown
																dropdownMode="select"
																disabled={true}
															/>
															{/* <div className="invalid-feedback">
                                                                    {errors.receiptdate && "Receipt Date  is required"}
                                                            </div> */}
														</div>
													</div>
												</div>
												<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Creation Date")} <Tooltip content={t("Creation Date")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<DatePicker
																// {...register("creationtdate", { required: true })}
																className="form-control datepick"
																selected={creation_date}
																// onChange={(date) => handelReceipt_Date(date)}
																name="creationdate"
																placeholderText={"mm/dd/yyyy"}
																showYearDropdown // year show and scrolldown alos
																scrollableYearDropdown
																showMonthDropdown
																dropdownMode="select"
																disabled={true}
															/>
															{/* <div className="invalid-feedback">
                                                                    {errors.receiptdate && "Receipt Date  is required"}
                                                            </div> */}
														</div>
													</div>
												</div>
												<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Applied Amount")} <Tooltip content={t("AppliedAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
														<div className="col-lg-12">
															<input
																onChange={(e) => setApplied_amount(e.target.value)}
																disabled
																readonly type="text" id="applied_amount" name="applied_amount" className="form-control" />
														</div>
													</div>
												</div>
											</>
										)}
										<CheckButton style={{ display: "none" }} ref={checkBtn} />
									</Form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</>
)
}

export default CreateRecipts
